export const OrganizationUserStatus = {
    UNKNOWN: 0,
    INVITED: 1,
    ACTIVE: 2,
    DISABLED: 3,
    REMOVED: 4,
    JOINED: 5,
}
